module.exports = __webpack_public_path__ + "img/4everland_normal.5902f0cf.svg";